import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=974d087c&scoped=true"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=974d087c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974d087c",
  null
  
)

export default component.exports